import "core-js/modules/es.symbol";
import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.find";
import "core-js/modules/es.object.get-own-property-descriptor";
import "core-js/modules/es.object.keys";
import "core-js/modules/es.string.replace";
import "core-js/modules/web.dom-collections.for-each";
import "regenerator-runtime/runtime";

var _marked =
/*#__PURE__*/
regeneratorRuntime.mark(purchaseOnEnterSaga);

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { select, call } from 'redux-saga/effects';
import { fetchEntityIfNeeded } from '@classpass/saga-tools';
import { livePlansByMsa, userProfile } from 'redux/saga/entities/bound';
import { isLoggedIn, memberStatus as getMemberStatus } from 'redux/saga/selectors';
import { geodetectMsa, scrollToTop } from 'redux/saga/helpers';
import requireMembershipSaga from 'routes/helpers/requireMembershipStatus';
import { memberStatus } from 'enums/memberStatus';
import Base64Deriver from 'derivers/Base64';
import { userNeedsPhoneVerification } from 'features/PhoneVerification/PhoneVerification.saga';
import PlanDeriver from 'derivers/Plan'; // redirects to the signup URL for this item if you are not logged in
// or redirects to / if you already have a subscription

export function purchaseOnEnterSaga(client, nextState, replaceState) {
  var loggedIn, isPurchaseLanding, isLive, userStatus, msa, msaId, livePlans, id, plan, verificationRequired;
  return regeneratorRuntime.wrap(function purchaseOnEnterSaga$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return select(isLoggedIn);

        case 2:
          loggedIn = _context.sent;
          isPurchaseLanding = /\/purchase\/pending($|\/)/.test(nextState.location.pathname);
          isLive = /\/purchase\/live($|\/)/.test(nextState.location.pathname);

          if (!isPurchaseLanding) {
            _context.next = 7;
            break;
          }

          return _context.abrupt("return");

        case 7:
          if (loggedIn) {
            _context.next = 11;
            break;
          }

          _context.next = 10;
          return call(replaceState, _objectSpread({}, nextState.location, {
            pathname: nextState.location.pathname.replace(/^\/purchase/, '/signup')
          }));

        case 10:
          return _context.abrupt("return", _context.sent);

        case 11:
          _context.next = 13;
          return call(fetchEntityIfNeeded, userProfile, [client]);

        case 13:
          _context.next = 15;
          return select(getMemberStatus);

        case 15:
          userStatus = _context.sent;

          if (!isLive) {
            _context.next = 36;
            break;
          }

          _context.next = 19;
          return call(scrollToTop);

        case 19:
          if (!memberStatus('ACTIVE', userStatus)) {
            _context.next = 34;
            break;
          }

          _context.next = 22;
          return call(geodetectMsa, client);

        case 22:
          msa = _context.sent;
          msaId = msa.id;
          _context.next = 26;
          return call(fetchEntityIfNeeded, livePlansByMsa, [client, msaId]);

        case 26:
          livePlans = _context.sent;
          id = Base64Deriver.decodeNumber(nextState.params.encodedLivePlanId);
          plan = livePlans.find(function (p) {
            return p.planId === id;
          });
          _context.next = 31;
          return call(replaceState, _objectSpread({}, nextState.location, {
            pathname: "/settings/live/".concat(PlanDeriver.isLiveTrial(plan) ? 'trial' : 'plans')
          }));

        case 31:
          return _context.abrupt("return", _context.sent);

        case 34:
          if (!memberStatus('CANCELLED', userStatus)) {
            _context.next = 36;
            break;
          }

          return _context.abrupt("return");

        case 36:
          _context.next = 38;
          return call(userNeedsPhoneVerification, client);

        case 38:
          verificationRequired = _context.sent;

          if (!verificationRequired) {
            _context.next = 43;
            break;
          }

          _context.next = 42;
          return call(replaceState, _objectSpread({}, nextState.location, {
            pathname: nextState.location.pathname.replace(/^\/purchase/, '/verify-phone')
          }));

        case 42:
          return _context.abrupt("return", _context.sent);

        case 43:
          _context.next = 45;
          return call(requireMembershipSaga, client, replaceState, [memberStatus('UNSUBSCRIBED')]);

        case 45:
        case "end":
          return _context.stop();
      }
    }
  }, _marked);
}